import { render, staticRenderFns } from "./FoundationService.vue?vue&type=template&id=d7c354ee&"
import script from "./FoundationService.vue?vue&type=script&lang=js&"
export * from "./FoundationService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports